module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "normal-width": "90vw",
      "width": "1120px"
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.isSummer ? _vm.SITE_CONFIG.skischool.map_summer : _vm.SITE_CONFIG.skischool.map
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29fca908"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/SkiSchoolLocationMap.vue
// module id = 912
// module chunks = 0